import { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SchedulerComponent from '../SchedulerComponent/SchedulerComponent';
import './NurseEducatorComponent.css';

export default function NurseEducatorComponent() {
  const [progress, setProgress] = useState(0);

  const handleUpdateStep = (currentStep) => {
    const totalSteps = 3; // Step 1, Step 2, Step 3 (success)
    // Progress: Step 1 = 0%, Step 2 = 50%, Step 3 = 100%
    const progress = ((currentStep - 1) / (totalSteps - 1)) * 100;
    setProgress(progress);
  };

  return (
    <div className="nurse-educator-component">
      <div className="container">

        <div className="row section-body">
          <div className="col-12 col-lg-auto mb-4 component-left">
            <h3 className="heading mb-4">
              <strong>Call a nurse educator now at</strong>
            </h3>
            <div className="contact-info mb-4">
              <div className="phone-block">
                <a className="phone-image" href="tel:+18334627452" aria-label="1-833-INBRIJA"></a>
                <p className="hours small mb-0">
                  <span className="text-nowrap">8 AM to 8 PM ET,</span>{' '}
                  <span className="text-nowrap">Monday through Friday</span>
                </p>
              </div>
            </div>
            <div className="educator-info-block mb-4">
              <div className="educator-image-block">
                <LazyLoadImage src='/assets/images/nurse-educator-actor.png' alt='Head shot of a nurse educator smiling' />
                <p className="caption mb-0">Actor portrayal</p>
              </div>
              <p className="educator-description text-start">Nurse Educators are available to support you with additional training by phone or video and to answer any questions about how to use the inhaler.</p>
            </div>
            <ul className="features-list check-style">
              <li>
                <span></span>Get one-on-one support for INBRIJA
              </li>
              <li>
                <span></span>Answers to your INBRIJA questions
              </li>
              <li>
                <span></span>Demonstrations of how to use INBRIJA
              </li>
              <li>
                <span></span>Paid by Merz Therapeutics. Not affiliated with <span className="text-nowrap">INBRIJA prescribers</span>
              </li>
          </ul>
          </div>

          <div className="col-12 col-lg-auto px-0 mb-4 component-middle">
            <span><strong>OR</strong></span>
          </div>

          <div className="col-12 col-lg-auto mb-4 component-right">
            <div className="d-flex flex-column flex-sm-row align-items-center mb-4">
              <h3 className="heading mb-0">
                <span className="text-nowrap">Schedule a call back</span>
              </h3>
              <div className="inb-progress-bar">
                <div className="progress-fill" id="progressFill" style={{ width:  progress + '%'}}></div>
              </div>
            </div>
            <SchedulerComponent onUpdateProgress={handleUpdateStep} />
          </div>
        </div>
      </div>
    </div>
  )
}